// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --muted-container-background-color: var(--addition-50);
  --muted-icon-fill-color: var(--addition-80);
}

.MutedBadge__icon-container-c4dda9 {
  background-color: var(--muted-container-background-color);
  border-radius: 24px;
  width: 24px;
  height: 24px;
}

.MutedBadge__icon-container-c4dda9 .MutedBadge__icon-e5cd06 {
  fill: var(--muted-icon-fill-color);
  padding: var(--indent-4px);
}`, "",{"version":3,"sources":["webpack://./src/main/LiveStreaming/SharedComponents/MutedBadge/styles.m.css"],"names":[],"mappings":"AAAA;EACE,sDAAA;EACA,2CAAA;AACF;;AAEA;EACE,yDAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,kCAAA;EACA,0BAAA;AACF","sourcesContent":[":root {\n  --muted-container-background-color: var(--addition-50);\n  --muted-icon-fill-color: var(--addition-80);\n}\n\n.icon-container {\n  background-color: var(--muted-container-background-color);\n  border-radius: 24px;\n  width: 24px;\n  height: 24px;\n}\n\n.icon-container .icon {\n  fill: var(--muted-icon-fill-color);\n  padding: var(--indent-4px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon-container": `MutedBadge__icon-container-c4dda9`,
	"iconContainer": `MutedBadge__icon-container-c4dda9`,
	"icon": `MutedBadge__icon-e5cd06`
};
module.exports = ___CSS_LOADER_EXPORT___;
